import React from 'react';
import { ProcessedChildren } from '../ProcessedChildren/ProcessedChildren';

export const UnorderedListRenderer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <ul role="list" className={className}>
      <ProcessedChildren>{children}</ProcessedChildren>
    </ul>
  );
};
